import app from 'flarum/forum/app';
import { cart, fetchProducts, formatPrice } from './shop';
const cache = new Map();
function load(ids) {
  const missing = Array.from(new Set(ids.filter(id => !cache.has(id))));
  if (missing.length) {
    const request = fetchProducts(missing).catch(() => []);
    missing.forEach(id => cache.set(id, request.then(products => products.find(p => p.id === id))));
  }
  return ids.map(id => cache.get(id));
}

/**
 * Turns the `.ShopProduct` placeholders rendered from [product=..] tags into product cards.
 * Built with plain DOM because it lives inside the post's server-rendered HTML.
 */
export function hydrateProducts(root) {
  if (!root) return;
  const elements = Array.from(root.querySelectorAll('.ShopProduct[data-product-id]:not([data-hydrated])'));
  if (!elements.length) return;
  elements.forEach(el => el.setAttribute('data-hydrated', ''));
  load(elements.map(el => Number(el.dataset.productId))).forEach((promise, i) => {
    promise.then(product => renderCard(elements[i], product));
  });
}
function make(tag, className, text) {
  const el = document.createElement(tag);
  el.className = className;
  if (text !== undefined) el.textContent = text;
  return el;
}
function renderCard(el, product) {
  el.textContent = '';
  if (!product) {
    el.classList.add('ShopProduct--missing');
    el.textContent = 'This product is no longer available.';
    return;
  }
  if (product.image_url) {
    const img = make('img', 'ShopProduct-image');
    img.src = product.image_url;
    img.alt = '';
    img.loading = 'lazy';
    el.append(img);
  }
  const info = make('div', 'ShopProduct-info');
  info.append(make('div', 'ShopProduct-name', product.name));
  info.append(make('div', 'ShopProduct-meta', formatPrice(product.price) + (product.vendor ? ` · sold by ${product.vendor}` : '')));
  if (product.description) info.append(make('div', 'ShopProduct-description', product.description));
  const actions = make('div', 'ShopProduct-actions');
  const addButton = make('button', 'Button Button--primary');
  addButton.type = 'button';
  const checkoutLink = make('a', 'Button', 'Checkout');
  checkoutLink.href = app.route('abdulrehman-shop.checkout');
  checkoutLink.addEventListener('click', e => {
    e.preventDefault();
    m.route.set(app.route('abdulrehman-shop.checkout'));
  });
  const refresh = () => {
    const quantity = cart.quantityOf(product.id);
    addButton.textContent = quantity ? `Add another (${quantity} in cart)` : 'Add to cart';
    checkoutLink.style.display = quantity ? '' : 'none';
  };
  addButton.addEventListener('click', () => {
    cart.add(product);
    refresh();
    m.redraw(); // updates the cart count in the header
  });
  refresh();
  actions.append(addButton, checkoutLink);
  info.append(actions);
  el.append(info);
}